import * as React from "react";
import { PropertyFiltersComponentProps } from "../typings";
import { FlexClickTracker } from "components/utility/analytics/FlexClickTracker/FlexClickTracker";
import { PROPERTY_FILTERS } from "components/flexComponents/PropertyFilters/PropertyFilters";
import { UitkButtonToggle } from "uitk-react-button-toggle";

const ButtonToggleTracked = FlexClickTracker(UitkButtonToggle);

export const ButtonToggle = (props: PropertyFiltersComponentProps) => {
  const { filterName, option, context, moduleName } = props;
  const [isSelected, setIsSelected] = React.useState(context.isSelected(filterName, option.optionValue!));

  React.useEffect(() => {
    context.addListener(filterName, option.optionValue!, setIsSelected);
  }, []);

  const onChange = () => {
    context.toggleSelection(filterName, option.optionValue!);
  };

  return (
    <ButtonToggleTracked
      id={`${filterName}-${option.optionValue}`}
      labelText={option.label}
      altText={option.selectedLabel}
      moduleName={PROPERTY_FILTERS}
      rfrr={`${moduleName}.${filterName}.${option.optionValue}.${!isSelected}`}
      value={option.optionValue}
      checked={isSelected}
      onChange={onChange}
      data-testid={option.selectedLabel}
    />
  );
};
